import * as React from "react";
import {
  useController,
  FieldValues,
  UseControllerProps,
} from "react-hook-form";
import { RichText, RichTextProps } from "../rich-text";
import { useDivideControlProps } from "./hooks";

type FormRichTextProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> &
    Omit<RichTextProps, "value" | "onChange" | "defaultValue">;

function FormRichTextInner<TFieldValues extends FieldValues>(
  props: FormRichTextProps<TFieldValues>,
  ref?: React.ForwardedRef<HTMLDivElement>
) {
  const [richTextProps, controllerProps] = useDivideControlProps<
    TFieldValues,
    FormRichTextProps<TFieldValues>
  >(props);

  const {
    field: { value, onChange, onBlur },
  } = useController(controllerProps);

  return (
    <RichText
      ref={ref}
      value={typeof value === "string" ? value : ""}
      onChange={onChange}
      onBlur={onBlur}
      {...richTextProps}
    />
  );
}

const FormRichText = React.forwardRef(FormRichTextInner) as <
  TFieldValues extends FieldValues
>(
  props: FormRichTextProps<TFieldValues> & {
    ref?: React.ForwardedRef<HTMLDivElement>;
  }
) => ReturnType<typeof FormRichTextInner>;

export { FormRichText };
export type { FormRichTextProps };
